import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import SearchBox from "./SearchBox";
// import { appConfigs } from '../config'
import { connect } from "react-redux";

class Header extends React.Component {
  handleClick = () => {
    this.props.dispatch({
      type: "SHOW_FILTER_DIV",
      payload: { showFilterDiv: true },
    });
  };

  closePopup = () => {
    this.props.dispatch({
      type: "HIDE_FILTER_DIV",
      payload: { showFilterDiv: false },
    });
  };

  render() {
    return (
      <div className="container-fluid header">
        <div className="row">
          <div className="col-lg-1">
            <Link to={"/edge/office/dashboard/"}>
              {" "}
              <img
                alt="CRE Matrix Logo"
                src="/edge/images/cre_edge_logo.png"
                className="creMatrixLogo"
              />
            </Link>
          </div>
          <div
            className="col-lg-9 searchBarContainer"
            ref={(node) => (this.node = node)}
          >
            {/* sample config variable {appConfigs.importantData} */}
            <input
              type={"text"}
              name="search"
              className="searchBar"
              placeholder="Search Property, Tenant, Landlord, Anything..."
              onClick={this.handleClick}
              autoComplete="off"
            />

            {this.props.showFilterDiv && (
              <SearchBox onChange={this.closePopup} />
            )}
          </div>
          <div className="col-lg-2 iconContainer">
            {/* <Link to="#">
              <FontAwesomeIcon icon={faBell} />
              <span className="tip">10</span>
            </Link> */}
            <Link to="#">
              <FontAwesomeIcon icon={faUser} />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    showFilterDiv: state.showFilterDiv,
  };
};

export default connect(mapStateToProps, null)(Header);
